/** Paleta do bloco de assinatura (tela e PDF), alinhada à identidade visual. */
export const ASSINATURA_CORES = {
  marca: "#1a4a9e",
  avatarBg: "#e1ecff",
  /** jsPDF setFillColor / setTextColor */
  marcaRgb: [26, 74, 158],
  avatarFillRgb: [225, 236, 255],
  avatarStrokeRgb: [191, 219, 254],
};

/**
 * Iniciais a partir do nome completo (primeira letra do primeiro e do último token).
 */
export function iniciaisNomeCompleto(nome) {
  const s = String(nome ?? "").trim();
  if (!s) return "?";
  const partes = s.split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "?";
  if (partes.length === 1) {
    const w = partes[0];
    return w.length >= 2 ? w.slice(0, 2).toUpperCase() : (w[0] + w[0]).toUpperCase();
  }
  const a = partes[0][0] || "";
  const b = partes[partes.length - 1][0] || "";
  return (a + b).toUpperCase() || "?";
}

/**
 * Formata CNPJ para exibição (XX.XXX.XXX/XXXX-XX). Retorna null se não tiver 14 dígitos.
 */
export function formatCnpjParaExibicao(cnpj) {
  const d = String(cnpj ?? "").replace(/\D/g, "");
  if (d.length !== 14) return null;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}
